// Single source of truth for the panel orientation in the frontend.
// The backend may return the enum name ("SpaceOriented") or its number (1),
// and the settings panel sends numbers, so always normalise through here.

export const ORIENTATION = {
  SECTION: 0,
  SPACE: 1,
  FLEXIBLE: 2,
};

const BY_NAME = {
  SectionOriented: ORIENTATION.SECTION,
  SpaceOriented: ORIENTATION.SPACE,
  FlexibleOriented: ORIENTATION.FLEXIBLE,
};

export const normalizeOrientation = (value) => {
  if (typeof value === "number" && Object.values(ORIENTATION).includes(value)) return value;
  return BY_NAME[value] ?? ORIENTATION.SECTION;
};

export const ORIENTATION_OPTIONS = [
  { value: ORIENTATION.SECTION, label: "Section mode" },
  { value: ORIENTATION.SPACE, label: "Space mode" },
  { value: ORIENTATION.FLEXIBLE, label: "Intelligent mode" },
];

const ENDPOINTS = {
  [ORIENTATION.SECTION]: "generate-device-placements",
  [ORIENTATION.SPACE]: "generate-device-placements-optimize",
  [ORIENTATION.FLEXIBLE]: "generate-device-placements-flexible",
};

export const placementEndpoint = (projectId, orientation) =>
  `/projects/${projectId}/enclosure/${ENDPOINTS[normalizeOrientation(orientation)]}`;

// ── Rail orientation per device (Flexible Oriented only) ──────────────────
// Sent as a number (0/1/2) like the orientation; the backend may return
// either the number or the enum name.
export const RAIL = { HORIZONTAL: 0, VERTICAL: 1, AUTO: 2 };

const RAIL_BY_NAME = { Horizontal: RAIL.HORIZONTAL, Vertical: RAIL.VERTICAL, Auto: RAIL.AUTO };

export const normalizeRail = (value) => {
  if (typeof value === "number" && Object.values(RAIL).includes(value)) return value;
  return RAIL_BY_NAME[value] ?? RAIL.HORIZONTAL;
};

export const isVerticalRail = (value) => normalizeRail(value) === RAIL.VERTICAL;

// Click order of the toggle in the tree: Horizontal -> Vertical -> Auto -> Horizontal
export const nextRail = (value) => {
  switch (normalizeRail(value)) {
    case RAIL.HORIZONTAL: return RAIL.VERTICAL;
    case RAIL.VERTICAL: return RAIL.AUTO;
    default: return RAIL.HORIZONTAL;
  }
};

export const RAIL_LABEL = {
  [RAIL.HORIZONTAL]: "Horizontal rail",
  [RAIL.VERTICAL]: "Vertical rail",
  [RAIL.AUTO]: "Auto (engine decides per band)",
};